/**
 * @file Login screen — STRV logo + Google sign-in button.
 *
 * Every verified @strv.com account passes the gate. What they see after
 * sign-in is decided by isAdmin() in main.js + the Firestore rules.
 */

import { el, clear }    from './utils.js';
import { svgFromStandard } from './lib/svg.js';
import { icon }          from './standard/js/icons.js';
import { strvLogo }     from './logo.js';
import { signInWithGoogle, emulatorSignIn } from './auth.js';

export function renderLogin(host) {
  clear(host);

  // Emulator-only: `?emu-login=<email>` signs in with the harness password so
  // the headless screenshot run (scripts/mobile-harness) never needs the
  // Google popup. Vite inlines VITE_USE_EMULATORS at build time, so this
  // whole branch is dead code in the production bundle.
  if (import.meta.env.VITE_USE_EMULATORS === 'true') {
    const email = new URLSearchParams(location.search).get('emu-login');
    if (email) emulatorSignIn(email).catch((err) => console.error('[login] emulator sign-in failed', err));
  }

  const errorBox = el('div', { class: 'login-error', hidden: true });

  // The brand's call-to-action: label left, arrow right (standard .btn-lg).
  const button = el('button', {
    class: 'btn btn-primary btn-lg',
    onClick: async () => {
      errorBox.hidden = true;
      try {
        await signInWithGoogle();
        // onAuth listener in main.js handles re-render.
      } catch (err) {
        errorBox.hidden = false;
        errorBox.textContent = err.message || 'Sign-in failed.';
      }
    },
  }, 'Sign in with Google', svgFromStandard(icon('arrowRight')));

  const shell = el('div', { class: 'login-shell' },
    el('a', { class: 'logo', href: 'https://strv.com', target: '_blank', rel: 'noopener', 'aria-label': 'STRV' }, strvLogo()),
    el('div', { class: 'login-box' },
      el('h1', null, 'Gear'),
      el('p', null, 'Sign in with your STRV Google account.'),
      button,
      errorBox,
    ),
  );

  host.appendChild(shell);
}
